import React from 'react';
import ViewOrders from '../ViewOrders/ViewOrders';

const DashBoardHome = () => {
    return (
        <div>
            <ViewOrders></ViewOrders>
        </div>
    );
};

export default DashBoardHome;